import { render, staticRenderFns } from "./EventMenu.vue?vue&type=template&id=1ccd71c6"
import script from "./EventMenu.vue?vue&type=script&lang=js"
export * from "./EventMenu.vue?vue&type=script&lang=js"
import style0 from "./EventMenu.vue?vue&type=style&index=0&id=1ccd71c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports